import { RB100_LOGO, GOV_SPONSOR, GOLD_SPONSORS, VENUE } from "../lib/api";
import { Link } from "react-router-dom";
import { MapPin, ExternalLink } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="main-footer"
    className="border-t border-rb-border bg-rb-surface mt-24"
  >
    <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <div className="flex items-center gap-4 mb-4">
          <div className="bg-white p-1 h-24 w-24 flex items-center justify-center border border-rb-border">
            <img src={RB100_LOGO} alt="RB100 — Since 2002" className="h-full w-full object-contain" />
          </div>
        </div>
        <p className="text-sm text-rb-textMuted leading-relaxed max-w-md">
          فريق شباب المدينة — نادي RB100. كلاسيك ومعدّلة، حضور وأصالة منذ ٢٠٠٢.
        </p>
        <a
          href={VENUE.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-venue-link"
          className="mt-5 inline-flex items-center gap-2 text-sm text-rb-ink hover:text-rb-red transition-colors"
        >
          <MapPin className="w-4 h-4" />
          {VENUE.name}
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.25em] text-rb-textMuted uppercase mb-4">
          النادي
        </h4>
        <p className="text-sm text-rb-ink leading-relaxed">
          نادي RB100
          <br />
          <span className="text-rb-red font-bold">المدينة المنورة · منذ ٢٠٠٢</span>
        </p>
        <ul className="space-y-2 text-sm mt-5">
          <li>
            <a href="/#about" className="text-rb-ink hover:text-rb-red transition-colors">
              عن النادي
            </a>
          </li>
          <li>
            <a href="/#gallery" className="text-rb-ink hover:text-rb-red transition-colors">
              المعرض
            </a>
          </li>
          <li>
            <a href="/#contact" className="text-rb-ink hover:text-rb-red transition-colors">
              تواصل معنا
            </a>
          </li>
          <li>
            <Link to="/admin/login" data-testid="footer-admin-login" className="text-rb-ink hover:text-rb-red transition-colors">
              دخول الإدارة
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.25em] text-rb-textMuted uppercase mb-4">
          الرعاة
        </h4>
        <div className="space-y-3">
          <div className="flex items-center gap-3 bg-white border border-rb-border p-2">
            <div className="h-9 w-9 bg-white shrink-0 flex items-center justify-center border border-rb-border/60">
              <img src={GOV_SPONSOR.logo} alt="" className="max-h-8 max-w-8 object-contain" />
            </div>
            <div className="text-[11px] leading-tight">
              <div className="text-rb-ink font-bold">{GOV_SPONSOR.name}</div>
              <div className="text-[9px] text-rb-textMuted tracking-widest uppercase">حكومي</div>
            </div>
          </div>
          {GOLD_SPONSORS.map((s) => (
            <a
              key={s.name}
              href={s.url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-rb-border hover:border-amber-500 transition-colors p-2"
            >
              <div className="h-9 w-9 shrink-0 bg-white flex items-center justify-center">
                <img src={s.logo} alt="" className="max-h-8 max-w-8 object-contain" />
              </div>
              <div className="text-[11px] leading-tight flex-1">
                <div className="text-rb-ink font-bold">{s.name}</div>
                <div className="text-[9px] text-amber-600 tracking-widest uppercase">راعي النادي</div>
              </div>
              <ExternalLink className="w-3.5 h-3.5 text-rb-textMuted shrink-0" />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-rb-border bg-white">
      <div className="max-w-7xl mx-auto px-6 py-5 text-center text-xs text-rb-textMuted">
        © 2025 RB100 Classic Sports Cars Club · جميع الحقوق محفوظة
      </div>
    </div>
  </footer>
);
